export default {
    new: 'New',
    remove: 'Remove micro-trend from this work space',
    noTranslation: 'no English translation available',
    marker: 'Company-micro-trend',
    noAction: 'Sign up for a premium account<br />to view all content.'
}
